import Flickity from 'flickity';

const CliniciansSlider = () => {

    const sliders = document.querySelectorAll('[data-clinicians]');

    Array.from(sliders).forEach(slider => {

        if (typeof slider != "undefined" && slider != null) {

            // Flickity options, defaults
            var options = {
                cellSelector: '.clinicians__col',
                adaptiveHeight: false,
                //cellAlign: 'left',
                contain: false,
                pageDots: true,
                prevNextButtons: false,
                watchCSS: true,
                wrapAround: true,
                percentPosition: false
            };

            // enable prev/next buttons at 768px
            if ( matchMedia('screen and (min-width: 768px)').matches ) {
                options.wrapAround = true;
            }

            new Flickity( slider, options);

            // Look for all Clinician elements that have aria-hidden="true" and change to aria-hidden="false"
            const clinicianCols = slider.querySelectorAll('.clinicians__col[aria-hidden="true"]');
            Array.from(clinicianCols).forEach(clinicianCol => {
                    clinicianCol.setAttribute('aria-hidden', 'false');
                }
            );
        }
    });
}

export default CliniciansSlider;
